import { CommonModule } from '@angular/common';
import { Component, output } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DynamicDialogConfig, DynamicDialogModule, DynamicDialogRef } from 'primeng/dynamicdialog';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputTextModule } from 'primeng/inputtext';
import { GenericErrorResponse } from '../../../../../core/models/generic-response.model';
import { ReferentialsAdrService } from '../referentials-adr.service';
import { InlineResponse } from '../../../../../core/models/inline-response.model';
import { Subject } from 'rxjs';
import { ToastModule } from 'primeng/toast';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-add-adr',
  standalone: true,
  imports: [CommonModule, DialogModule, ButtonModule, AvatarModule, AvatarGroupModule, DynamicDialogModule, InputTextModule, InputGroupModule, InputGroupAddonModule, ConfirmDialogModule, ReactiveFormsModule, CardModule, MessagesModule, MessageModule, ToastModule, ProgressSpinnerModule, TranslocoModule],
  providers: [MessageService],
  templateUrl: './add-adr.component.html',
  styleUrl: './add-adr.component.css',
})
export class AddAdrComponent {
  private destroy$: Subject<boolean> = new Subject<boolean>();

  errors: GenericErrorResponse[] = [];
  submitting: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private config: DynamicDialogConfig,
    private ref: DynamicDialogRef,
    private messageService: MessageService,
    private adrServices: ReferentialsAdrService,
    private translocoService: TranslocoService
  ) {}

  adrForm = this.formBuilder.group({
    classe: ['', [Validators.maxLength(32)]],
    codeDanger: ['', [Validators.maxLength(5)]],
    codeHecate: ['', [Validators.required, Validators.maxLength(10), Validators.pattern('^[0-9]*$')]],
    codeTunnels: ['', [Validators.maxLength(20)]],
    designation: ['', [Validators.required, Validators.maxLength(160)]],
    groupeEmballage: ['', [Validators.maxLength(10)]],
    numeroUN: ['', [Validators.required, Validators.pattern('^[0-9]*$')]],
  });

  userHasReadWritePermission: boolean = false;

  ngOnInit(): void {
    if (!!this.config.data) {
      this.userHasReadWritePermission = this.config.data.userHasReadWritePermission;
    }
  }

  addAdr() {
    this.submitting = true;

    this.adrServices
      .addAdrData(
        this.adrForm.get('classe')?.value ?? '',
        this.adrForm.get('codeDanger')?.value ?? '',
        Number(this.adrForm.get('codeHecate')?.value),
        this.adrForm.get('codeTunnels')?.value ?? '',
        this.adrForm.get('designation')?.value ?? '',
        this.adrForm.get('groupeEmballage')?.value ?? '',
        Number(this.adrForm.get('numeroUN')?.value),
      )
      .subscribe({
        next: (data) => {
          this.checkIfTypePrestationSuccessfull(data);
          this.submitting = false;
        },
        error: (error) => {
          this.messageService.add({ severity: 'error', summary: this.translocoService.translate('error.popup.titre.defaut'), detail: 'Une erreur est survenue ' + this.errors.map((e) => e.errorMsg), life: 3000 });
        },
      });
  }

  private checkIfTypePrestationSuccessfull(data: InlineResponse) {
    switch (data.success) {
      case true:
        this.close(true);
        break;
      case false:
        this.errors = data.errors.length > 0 ? data.errors : [data.exception];
        this.messageService.add({ severity: 'error', summary: this.translocoService.translate('error.popup.titre.defaut'), detail: 'Une erreur est survenue ' + this.errors.map((e) => e.errorMsg), life: 3000 });
        break;
    }
  }

  close(result: boolean): void {
    this.ref.close(result);
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
